import { DeviceVariantType } from '@unifyapps/defs/types/deviceVariant';

export function getDimensionClasses(device: DeviceVariantType) {
  const widthClasses = 'w-screen max-w-full';

  let heightClasses: string;
  switch (device) {
    //for mobile and tablet, the height should be in svh as vh doesn't account for dynamic UI elements
    //show/hide their toolbars, vh doesn't update
    case DeviceVariantType.MOBILE:
    case DeviceVariantType.TABLET:
      heightClasses = 'h-svh';
      break;
    //for desktop, the height of the interface page should be in vh
    case DeviceVariantType.DESKTOP:
      heightClasses = 'h-screen min-h-screen';
      break;
    default:
      heightClasses = 'h-screen min-h-screen';
      break;
  }

  return `${widthClasses} ${heightClasses}`;
}
